import { createSlice } from '@reduxjs/toolkit'
import { API_GET_FEATURED_LISTING_STATUS, API_TOGGLE_FEATURED_LISTING } from '../constants/index'

const initialState = {
    featuredStatus: null,
}

export const toggleFeaturedListing = (restaurantId) => ({
    type: 'API',
    payload: {
        url: API_TOGGLE_FEATURED_LISTING,
        method: 'POST',
        data: { restaurantId },
        hideLoader: false,
        success: (data) => ({
            type: 'toggleFeaturedListing/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'toggleFeaturedListing/fail',
            payload: data,
        }),
    },
})

export const getFeaturedListingStatus = (restaurantId) => ({
    type: 'API',
    payload: {
        url: API_GET_FEATURED_LISTING_STATUS,
        method: 'POST',
        data: { restaurantId },
        hideLoader: false,
        success: (data) => ({
            type: 'getFeaturedListingStatus/success',
            payload: data,
        }),
        error: (data) => ({
            type: 'getFeaturedListingStatus/fail',
            payload: data,
        }),
    },
})

const FeaturedListingSlice = createSlice({
    name: 'FeaturedListing',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase('getFeaturedListingStatus/success', (state, action) => {
            state.featuredStatus = action.payload?.data ?? null
        })
        builder.addCase('getFeaturedListingStatus/fail', (state) => {
            state.featuredStatus = null
        })
        builder.addCase('toggleFeaturedListing/success', (state, action) => {
            state.featuredStatus = action.payload?.data ?? null
        })
        builder.addCase('toggleFeaturedListing/fail', (state) => {
            // keep existing status; caller handles error toast
        })
    },
})

export default FeaturedListingSlice.reducer
